import '../../../styles/templates/account.scss';
import $ from 'jquery';
import {FormInterceptor} from '../../ui/form-interceptor';
import {storageTracker} from '../../ui/utils/storage-tracker';

const $registerForm = $('#create_customer');
new FormInterceptor($registerForm, {
  type: 'register',
  storageTracker,
});
